import { Component, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent, UnrecoverableStateEvent } from '@angular/service-worker';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

import { environment as ENV } from '@environments/environment';
import { OverlayFacade } from '@modules/cds/facades/overlay.facade';

@Component({
  selector: 'cargamos-root',
  template: `
    <ng-progress [spinner]="false" [color]="'var(--cds-primary-color)'" />
    <router-outlet />
    <cds-cookie-consent-banner [cookieUrl]="cookiesLegalDocument" />
  `,
})
export class AppComponent {
  private readonly swUpdates: SwUpdate = inject(SwUpdate);
  private readonly overlayFacade: OverlayFacade = inject(OverlayFacade);
  private readonly translate: TranslateService = inject(TranslateService);

  public readonly cookiesLegalDocument: string = ENV.externalUrls.cookiesLegalDocument;

  constructor() {
    this.setupLanguage();
    this.swUpdates.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(() => this.reloadApp());

    /**
     * Handling an unrecoverable state
     * more information https://angular.io/guide/service-worker-communications
     */
    this.swUpdates.unrecoverable.subscribe((event: UnrecoverableStateEvent) => {
      // eslint-disable-next-line no-console
      console.log(`An error occurred that we cannot recover from: ${event.reason}`);
    });
  }

  private setupLanguage(): void {
    const defaultLanguage: string = 'es';
    this.translate.setDefaultLang(defaultLanguage);
    this.translate.use(defaultLanguage);
  }

  private reloadApp(): void {
    this.overlayFacade
      .showModalAlert({
        title: 'COMMON.NEW_VERSION_READY_TITLE',
        text: 'COMMON.NEW_VERSION_READY',
      })
      .pipe(filter(({ isConfirmed }) => isConfirmed))
      .subscribe(() => document.location.reload());
  }
}
